import { render, staticRenderFns } from "./HandlePage.vue?vue&type=template&id=18bad7c2&scoped=true&"
import script from "./HandlePage.vue?vue&type=script&lang=js&"
export * from "./HandlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bad7c2",
  null
  
)

export default component.exports